import FileUploadError from "./FileUploadError";
import Button, { ButtonModeE } from "../../components/Button/Button";

import styles from './fileUploaderError.module.scss';

export default (wrongLength: boolean, removePopup: () => void, errorMessage: string | boolean | undefined = undefined, children?: any) => ({
    header: <></>,
    body: <FileUploadError wrongLength={wrongLength} errorMessage={errorMessage} children={children}/>,
    footer: (
        <>
            {!wrongLength ? (
                <div className={styles.buttonsWrapper}>
                    <Button onClick={removePopup}>Ok</Button>
                </div>
            ) : (
                <div className={styles.buttonsWrapper}>
                    <Button mode={ButtonModeE.OUTLINED} onClick={removePopup}>Cancel</Button>
                    <Button onClick={removePopup}>Send</Button>
                </div>
            )}
        </>
    ),
    className: styles.popupWrapper
});